module.exports = __webpack_public_path__ + "static/img/settle-bc3.07d8212f.png";